import React from 'react';

const SvgArrowLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      width={props.width || 14}
      height={props.height || 14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.04746 12.9093L7.35371 13.6031C7.05996 13.8968 6.58496 13.8968 6.29434 13.6031L0.219336 7.5312C-0.0744141 7.23745 -0.0744141 6.76245 0.219336 6.47183L6.29434 0.396826C6.58809 0.103076 7.06309 0.103076 7.35371 0.396826L8.04746 1.09058C8.34434 1.38745 8.33809 1.87183 8.03496 2.16245L4.26934 5.74995H13.2506C13.6662 5.74995 14.0006 6.08433 14.0006 6.49995V7.49995C14.0006 7.91558 13.6662 8.24995 13.2506 8.24995H4.26934L8.03496 11.8375C8.34121 12.1281 8.34746 12.6125 8.04746 12.9093Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SvgArrowLeft;
